export default {
  // Page titles
  'products.title': 'Product Management',
  'products.statistics': 'Product Statistics Overview',
  'products.list': 'Product List',

  // Statistics
  'products.stats.loading': 'Loading statistics...',
  'products.stats.total': 'Total Products',
  'products.stats.inStock': 'In Stock',
  'products.stats.preorder': 'Pre-order',
  'products.stats.outOfStock': 'Out of Stock',
  'products.stats.listed': 'Listed',
  'products.stats.unlisted': 'Unlisted',
  'products.stats.onSale': 'Sale',
  'products.stats.showroomAvailable': 'Showroom Available',
  'products.stats.matrixTitle': 'Product Stats Comparison (by Type × Promotion)',
  'products.stats.matrixLoading': 'Loading comparison data...',
  'products.stats.matrixEmpty': 'No comparison data available.',
  'products.stats.matrixColumnAll': 'All Products',
  'products.tab.statsComparison': 'Stats Comparison',
  'products.tab.productList': 'Product List',

  // Table columns
  'products.table.productInfo': 'Product Info',
  'products.table.price': 'Price',
  'products.table.compareAtPrice': 'Compare At Price',
  'products.table.stockStatus': 'Stock Status',
  'products.table.listingStatus': 'Listing Status',
  'products.table.channel': 'Channel',
  'products.table.promotionStatus': 'Promotion Status',
  'products.table.promotionLabels': 'Promotion Labels',
  'products.table.dealDate': 'Deal Date',
  'products.table.merchStatus': 'Merch Status',
  'products.table.category': 'Category',
  'products.table.productFamily': 'Product Family',
  'products.table.extendedAttributes': 'Extended Attributes',
  'products.table.dataComparison': 'Data Comparison',
  'products.table.actions': 'Actions',

  // Product status tags
  'products.status.inStock': 'In Stock',
  'products.status.preorder': 'Pre-order',
  'products.status.outOfStock': 'Out of Stock',
  'products.status.listed': 'Listed',
  'products.status.unlisted': 'Unlisted',
  'products.status.onSale': 'On Sale',
  'products.status.noPromotion': 'No Promotion',
  'products.status.showroomAvailable': 'Showroom Available',
  'products.status.newArrival': 'New Arrival',
  'products.status.sameAsSku': 'Same as SKU',
  'products.status.expired': 'Expired',
  'products.channel.global': 'GLOBAL',
  'products.channel.web': 'Web',
  'products.channel.pos': 'POS',
  'products.channel.default': 'Default',

  // Data comparison
  'products.comparison.shopifyVsDear': 'Shopify vs DEAR:',
  'products.comparison.dearVsInno': 'DEAR vs INNO:',
  'products.comparison.stock': 'Stock',
  'products.comparison.status': 'Status',
  'products.comparison.pi': 'PI',
  'products.comparison.allPlatformsSynced': 'All Platforms Synced',
  'products.comparison.syncRequired': 'Sync Required',
  'products.comparison.noData': 'No Data',

  // Actions
  'products.actions.viewDetails': 'View Details',
  'products.actions.syncInventory': 'Sync Inventory',
  'products.actions.export': 'Export',
  'products.actions.refresh': 'Refresh',
  'products.actions.reload': 'Reload Data',
  'products.actions.syncMySQL': 'Sync from DEAR',
  'products.actions.importMetafield': 'Import Metafield',

  // Search and filters
  'products.search.placeholder': 'Search product name, SKU or barcode',
  'products.filter.stockStatus': 'Stock Status',
  'products.filter.listingStatus': 'Listing Status',
  'products.filter.promotionStatus': 'Promotion Status',
  'products.filter.vendor': 'Vendor',

  // Pagination
  'products.pagination.items': 'items',
  'products.pagination.of': 'of',

  // Import modal
  'products.import.title': 'Import Product Metafield',
  'products.import.description': 'Please upload Products.csv or Excel file, the system will automatically parse and import to MySQL products table.',
  'products.import.supportedFields': 'Template columns: Variant SKU (required, the barcode), Category, and the Metafield columns. Download the template and fill it in.',
  'products.import.downloadTemplate': 'Download Template',
  'products.import.downloadTemplateHint': 'Download sample CSV template with correct column format',
  'products.import.templateDownloaded': 'Template downloaded successfully',
  'products.import.selectFile': 'Select CSV or Excel file',
  'products.import.updateExisting': 'Update existing records',
  'products.import.startImport': 'Start Import',
  'products.import.cancel': 'Cancel',
  'products.import.onlySupport': 'Only CSV and Excel files are supported (.csv, .xlsx, .xls)',

  // Import results
  'products.import.results.total': 'Total',
  'products.import.results.inserted': 'Inserted',
  'products.import.results.updated': 'Updated',
  'products.import.results.failed': 'Failed',
  'products.import.results.errorDetails': 'Error Details:',
  'products.import.results.moreErrors': 'more errors...',

  // Messages
  'products.message.exportSuccess': 'Exported {count} products successfully',
  'products.message.exportFailed': 'Failed to export products',
  'products.message.importFailed': 'Import failed, please check file format',
  'products.message.selectFile': 'Please select CSV or Excel file',
  'products.message.noData': 'No data available',
  'products.message.syncStarted': 'Syncing products from DEAR...',
  'products.message.syncSuccess': 'Synced {count} products from DEAR successfully',

  // Export
  'products.export.filename': 'products_{date}.csv',
};